import type { DashboardRange } from "@adpilot/shared";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AddCampaignsDialog } from "@/components/portfolio/AddCampaignsDialog";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface PortfolioCampaignsMenuProps {
  portfolioId: string;
  /** The portfolio's own shop — the wizard must land there, not on X-Shop-Id. */
  shopId: string;
  range: DashboardRange;
}

/**
 * Xnurta parity (ADP-137): the campaign table's「+ 广告活动」primary button with
 * 新建广告活动 / 添加广告活动. Callers render it only for owner/admin.
 */
export function PortfolioCampaignsMenu({
  portfolioId,
  shopId,
  range,
}: PortfolioCampaignsMenuProps) {
  const { t } = useTranslation("portfolios");
  const navigate = useNavigate();
  const [addOpen, setAddOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger render={<Button size="sm" />}>
          <IconPlus data-icon="inline-start" />
          {t("detail.campaignsMenu.trigger")}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" sideOffset={4} className="w-36">
          <DropdownMenuGroup>
            <DropdownMenuItem
              onClick={() =>
                void navigate({ to: "/campaigns/new", search: { shopId, portfolioId } })
              }
            >
              {t("detail.campaignsMenu.create")}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setAddOpen(true)}>
              {t("detail.campaignsMenu.add")}
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <AddCampaignsDialog
        portfolioId={portfolioId}
        range={range}
        open={addOpen}
        onOpenChange={setAddOpen}
      />
    </>
  );
}
